<template lang="pug">
.report
    PageTitle(
        pagetitle="转化效果分析过程",
        tip="对影响账户转化数据的相关指标进行深入分析，找出影响转化效果的问题指标，针对性给出优化建议。",
        :showTime="false"
    )

    .zone.opt-zone 
        div
            TableTitle(icon="fa fa-signal" title="展现量&点击率分析")  
            div.timespan-wrapper          
                span.timespan 最近7天
            div(v-if="currentTopChart == 'quad'")
                QuadChart(
                    :listSeries="getTopQuadSeries",
                    :avgSeries="topQuadAvgSeries",
                    :loading="topQuadLoading",
                    :axisNames="topQuadNames",
                    @quadPosition="setTopQuadPosition"
                )
                p.chart-tip(v-show="topQuadInfo") {{topQuadInfo}}
          

    .zone.opt-zone 
        TableTitle(icon="fa fa-signal" title="账户计划预算分析")  
        div
            div.bar-picker-wrapper
                v-date-picker(v-model="baseDate", :max-date="yesterday", :min-date="yearAgo")
   
        div(v-if="currentMidChart == 'bar'")
            table.mid-charts              
                tr
                      td(width="50%")
                          BarChart(
                              :hirizonal="hirizonalBar",
                              :series="getLeftBarSeries",
                              :color="leftBarColor",
                              :loading="leftBarLoading"
                          )

                      td(width="50%")
                          BarChart(
                              :hirizonal="hirizonalBar",
                              :series="getRightBarSeries",  
                              :color="rightBarColor",
                              :loading="rightBarLoading"
                          )
            p.chart-tip(v-show="leftBarSeries.length>0 || rightBarSeries.length>0", v-html="midBarContent")
        
        
    .zone.opt-zone
        TableTitle(icon="fa fa-signal" title="CPC&转化率分析")  
        div.timespan-wrapper          
            span.timespan 最近7天
        QuadChart(
            :listSeries="getBottomQuadSeries",
            :avgSeries="bottomQuadAvgSeries",
            :loading="bottomQuadLoading",
            :axisNames="bottomQuadNames",
            @quadPosition="setBottomQuadPosition"
        )
        p.chart-tip(v-show="bottomQuadInfo") {{bottomQuadInfo}}
</template>

<script>
import Vue from 'vue'
import Store from '../../store/store.js'
import Mixin from '../mixin.js'
import { getDateString, dateTimeFromRange } from '../../script/util';
import { QUAD_POSITION } from './constants';

export default {
    store : Store,
    data(){
        let yesterday = getDateString.yestoday()
        let date1 = new Date();
        date1.setFullYear(date1.getFullYear() - 1);

        return {
            currentTopChart: 'quad',
            currentMidChart: 'bar',
            yesterday : yesterday,
            baseDate : yesterday,
            yearAgo : getDateString(date1),
            hirizonalBar : true,
            commonLabel : '数据解读',
            
            topQuadSeries : [],
            topQuadAvg : {},
            topQuadLoading : false,
            topQuadContent : "",
            topQuadNames : {
                xName : '点击率均值',
                yName : '展现量均值'
            },
            topQuadPosition : 1,


            leftBarSeries : [],
            leftBarColor : ['#F2C230','#56BF8B'],
            leftBarLoading : false,
            rightBarSeries : [],
            rightBarColor : ['#73ACE6','#F2C230','#56BF8B'],
            rightBarLoading : false,
            underbudgetedPlanNum : 0,
            lossPv : 0,
            lineContent : '基于您网站现有广告展现量水平，采纳优化建议后预估展现量为上图红线部分',           
            
            
            bottomQuadSeries : [],
            bottomQuadAvg : {},
            bottomQuadLoading : false,
            bottomQuadContent : "",
            bottomQuadNames : {
                xName : '转化率均值',
                yName : 'CPC均值'
            },
            bottomQuadPosition : 1,


            countSelected : 'shownum',
            countList : [{
                title: "展示量",
                value: "shownum"
            },{
                title: "点击率",
                value: "clicknum"
            }]
       }
    },
    computed: {
        domainId() {
            return this.$store.state.domainId;
        },
        djid() { 
            return this.getQueryString('dj');
        },
        params() {
            return {
                domainId : this.domainId,
                djid : this.djid
            }
        },
        topQuadInfo(){
            switch (this.topQuadPosition) {
                case 1:
                    return "数据解读：您的账户与同行业客户相比，展现量、点击率表现均优，可采纳优化建议继续优化账户水平。";
                    break;
                case 2:
                    return "数据解读：您的账户与同行业客户相比，点击率较低，急需优化，展现量可持续优化。";
                    break;
                case 3:
                    return "数据解读：您的账户与同行相比，展现量、点击率均低于平均水平，急需优化。";
                    break;
                case 4:
                    return "数据解读：您的账户与同行业客户相比，展现量较低，急需优化，点击率可持续优化。";
                    break;
                default : 
                    break;
            }
        },
        bottomQuadInfo(){
            switch (this.bottomQuadPosition) {
                case 1:
                    return "数据解读：您的账户与同行业客户相比，转化率表现优，CPC较高。"; 
                    break;
                case 2:
                    return "数据解读：您的账户与同行业客户相比，转化率低、CPC高，急需优化。";
                    break;
                case 3:
                    return "数据解读：您的账户与同行相比，转化率低，急需优化。";
                    break;
                case 4:
                    return "数据解读：您的账户与同行业客户相比，转化率、CPC表现均优。";
                    break;
                default : 
                    break;
            }
        },
        getTopQuadSeries(){
            return this.fetchQuadSeries('top') || [];
        },
        getBottomQuadSeries(){
            return this.fetchQuadSeries('bottom') || [];
        },
        topQuadAvgSeries(){
            return this.fetchQuadAvg('top') || {};
        },
        bottomQuadAvgSeries(){
            return this.fetchQuadAvg('bottom') || {};
        },
        getLeftBarSeries() {
            return this.fetchBarSeries('left');
        },
        getRightBarSeries() {
            return this.fetchBarSeries('right');
        },
        midBarContent(){
            let value1 = this.underbudgetedPlanNum, value2 = this.lossPv;
            return `数据解读：您账户由于计划预算原因提前下线计划数共<span style='color:red'>${value1}</span>个，预估损失展现量<span style="color:red">${value2}</span>`;
        },
    },
    watch: {
        /*params: {
            handler: function() {
                  this.getQuadSeries();
                  this.getBarSeries();
              },
            deep: true
        },*/
        baseDate() {
            this.getBarSeries();
        },
    },
    mounted(){
        this.getQuadSeries();
        this.getBarSeries();
    },
    methods : {
        getQueryString(name){
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) { 
                return unescape(r[2]);}
            return null;
        },
        setTopQuadPosition(data){
            this.topQuadPosition = data;
        },
        setBottomQuadPosition(data){
            this.bottomQuadPosition = data;
        },
        setQuadSeries(type){
            if (!this.domainId) return Promise.resolve(null);
            this[type + 'QuadLoading'] = true;

            let seriesData = [], avgData = {};
            let quadData = {};
            let otherList = [], list = [];
            let maptype = type === 'top' ? 1 : 2 ;
            let quadListPromise = this.$http.get(`/api/aoAnalysis/mapReport`, { params: _.extend({ maptype : maptype}, this.params) });
            this.$store.dispatch("VUE_HTTP", [quadListPromise])
                .then( (res) => {
                    this[type + 'QuadLoading'] = false;
                    if(!res.list) return;
                    list = res.list;
                    otherList = res.list;
                    if (list[list.length-1].self && list[list.length-1] === 1) {
                        otherList = list.slice(0,list.length-1);
                    }
                    if (type === "top") {
                        otherList.map( item => {
                          seriesData.push({"value1":item.avg7adctr, "value2":item.avg7adpv});   
                        }); 

                        avgData.avgValue1 = res.avg.avg7adctr;
                        avgData.avgValue2 = res.avg.avg7adpv;
                        
                        seriesData[list.length-1].self = 1;
                        
                        this.topQuadSeries = seriesData;
                        this.topQuadAvg = avgData;
                    } else if (type === "bottom") {
                        otherList.map( item => {
                          seriesData.push({"value1":item.avg7trate, "value2":item.avg7cpc});   
                        });
                        
                        avgData.avgValue1 = res.avg.avg7trate;
                        avgData.avgValue2 = res.avg.avg7cpc;
                        
                        seriesData[list.length-1].self = 1;

                        this.bottomQuadSeries = seriesData;
                        this.bottomQuadAvg = avgData;
                    }

                    quadData.list = seriesData;
                    quadData.avg = avgData;
                    this[type + 'QuadLoading'] = false;
                });            
                return quadData; 
        },
        getQuadSeries(){
            if (!this.djid || this.djid == '0') return;
            ['top', 'bottom'].forEach( type => {
                this.setQuadSeries(type);
            });
        },
        fetchQuadSeries(type){
            let series = [];
            switch (type) {
                case 'top' :
                    return this.topQuadSeries;
                    break;
                case 'bottom' :
                    return this.bottomQuadSeries;
                    break;
                default : 
                    break;
            }
        },
        fetchQuadAvg(type){
            let avg = {};
            switch (type) {
                case 'top' :
                    return this.topQuadAvg;
                    break;
                case 'bottom' :
                    return this.bottomQuadAvg;
                    break;
                default : 
                    break;
            }
        },
        setBarSeries(type){
            if (!this.domainId) return Promise.resolve(null);
            this[type + "BarLoading"] = true;

            let plan = {}, pv = {};
            this.leftBarSeries = [];
            this.rightBarSeries = [];
            let seriesData = [];
            let barListPromise = this.$http.get(`/api/aoAnalysis/barChart`, { params: _.extend({ date: this.baseDate }, this.params) });
            this.$store.dispatch("VUE_HTTP", [barListPromise])
               .then( (res) => {
                   this[type + "BarLoading"] = false;
                   if (res.errno) {
                       this.$Modal.warn(res.errMsg);
                       return;
                   }
                   plan = res.plan;
                   pv = res.pv;

                   let lMax = plan.offline_plan_num >= plan.on_plan_num ? plan.offline_plan_num : plan.on_plan_num;
                   let rMax = pv.loss_impr >= pv.offline_plan_impr ? pv.loss_impr : pv.offline_plan_impr;
                   rMax = rMax >= pv.on_plan_impr ? rMax : pv.on_plan_impr;
                   
                   if (type === "left") {
                       seriesData.push({
                           value : plan.offline_plan_num || 0,
                           name : "提前下线",
                           itemStyle : {
                               normal : {
                                   color: this.leftBarColor[0]
                               }
                           },
                           max : lMax
                       },{
                           value : plan.on_plan_num || 0,
                           name : "正常计划",
                           itemStyle : {
                               normal : {
                                   color: this.leftBarColor[1]
                               }
                           },
                           max : lMax
                       });

                       this.leftBarSeries = seriesData;

                   } else if (type === "right") {
                       seriesData.push({
                           value : pv.loss_impr || 0,
                           name : "损失展现量",
                           itemStyle : {
                               normal : {
                                   color: this.rightBarColor[0]
                               }
                           },
                           max : rMax
                       },{
                           value : pv.offline_plan_impr || 0,
                           name : "提前下线计划展现量",
                           itemStyle : {
                               normal : {
                                   color: this.rightBarColor[1]
                               }
                           },
                           max : rMax
                       },{
                           value : pv.on_plan_impr || 0,
                           name : "正常计划展现量",
                           itemStyle : {
                               normal : {
                                   color: this.rightBarColor[2]
                               }
                           },
                           max : rMax
                       });

                       this.rightBarSeries = seriesData;
                       
                   }

                   this.underbudgetedPlanNum = plan.offline_plan_num || 0;
                   this.lossPv = pv.loss_impr || 0;
                    
                   return seriesData;
               });
        },
        getBarSeries(){
            if (!this.djid || this.djid == '0') return;
            this.setBarSeries('left');
            this.setBarSeries('right');
        },
        fetchBarSeries(type){
            let series = [];
            switch (type) {
                case 'left' :
                    return this.leftBarSeries;
                    break;
                case 'right' :
                    return this.rightBarSeries;
                    break;
                default : 
                    break;
            }
        }
    }
}
</script>
<style scoped>

@import '../../css/base/variables.css';

.mid-charts{
    width: 100%;
    padding-top: 10px;
}
.bar-picker-wrapper{ margin: 20px;}
.datepicker{ display: inline-block;}
.zone header{ 
    border-top: 1px solid #ccc;
    border-bottom : 1px solid #ccc;  
}
.charts{ border-top: none;}
.fr{ 
    float: right;
    margin: 15px 25px 10px;
}
.q-timespan{ margin: 15px 25px;}
.timespan-wrapper{
    padding-top: 15px;
    padding-left: 20px;
    box-sizing: border-box;
}
span.timespan{
    display: inline-block;
    margin-right: 12px;
    padding: 0 5px;
    cursor: pointer;
    color: #fff;
    background-color: #56bf8b;
}
</style>



// WEBPACK FOOTER //
// viewprocess.vue?91803c7e